import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../services/report/report.service';
import { SupportService } from '../../services/support/support.service';
import { SettingsService } from '../../services/settings/settings.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  supportActive: boolean = false;
  settingsActive: boolean = false;

  constructor(
    private reportService: ReportService,
    private supportService: SupportService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.reportService.init();
    // this.router.navigate(['reports', this.activeReportConfig.alias]);
    console.log('report screen init');

    // Subscribe to support active state
    this.supportService.supportActive$.subscribe((active) => {
      this.supportActive = active;
      console.log('support active state changed:', this.supportActive);
    });

    this.supportActive = this.supportService.isSupportActive();

    this.settingsService.settingsActive$.subscribe((active) => {
      this.settingsActive = active;
    });
    this.settingsActive = this.settingsService.isSettingsActive();
  }

}
